<template>
    <div class="popper-market-metric">
        <div class="popper-market-metric__content p-4 max-w-400">
            <h6 class="popper-market-metric__title">
                {{ title }}
            </h6>
            <p class="popper-market-metric__definition mt-2">
                {{ definition }}
            </p>
            <div class="popper-market-metric__more-info display-flex mt-4">
                <a
                    class="popper-market-metric__link text-accent cursor-pointer"
                    @click="setGlobalModal"
                >
                    {{ $t('definitionTooltips.more') }}
                </a>
                <font-awesome-icon
                    icon="fas fa-external-link"
                    class="popper-market-metric__icon ml-2 text-primary-darker"
                    size="sm"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
import { useAppStore } from '@/stores'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const props = defineProps({
    title: {
        type: String,
        required: true,
    },
    definition: {
        type: String,
        required: true,
    },
    moreInfo: {
        type: String,
        required: true,
    },
    zScoreInfo: {
        type: String,
        required: false,
    },
})

const setGlobalModal = () => {
    const appStore = useAppStore()
    const modalObj = {
        type: 'metric',
        caption: '',
        title: props.title,
        definition: props.definition,
        moreInfo: props.moreInfo,
        zScoreInfo: props.zScoreInfo,
    }
    appStore.setGlobalModal(modalObj)
    appStore.setShowGlobalModal(true)
}
</script>

<script>
export default {
    name: 'PopperMarketMetric',
}
</script>

<style lang="scss" scoped>
.popper-market-metric {
    max-width: 400px;

    &__title {
        font-weight: var(--font-weight-bold);
    }

    &__definition {
        color: var(--color-text-default);
    }

    &__link {
        color: var(--color-accent);
    }

    &__icon {
        color: var(--color-primary-darker);
    }
}
</style>
